import axios from 'axios'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import _ from 'lodash'
import router from '@/router'
import encryption from '@/utils/encryption.js'
import { getToken } from '@/utils/auth'
import { Message, Notification } from 'element-ui'
import Net from '@/constants/index'

const codeMessage = {
  200: '服务器成功返回请求的数据。',
  201: '新建或修改数据成功。',
  202: '一个请求已经进入后台排队（异步任务）。',
  204: '删除数据成功。',
  400: '发出的请求有错误，服务器没有进行新建或修改数据的操作。',
  401: '用户没有权限（令牌、用户名、密码错误）。',
  403: '用户得到授权，但是访问是被禁止的。',
  404: '发出的请求针对的是不存在的记录，服务器没有进行操作。',
  406: '请求的格式不可得。',
  410: '请求的资源被永久删除，且不会再得到的。',
  422: '当创建一个对象时，发生一个验证错误。',
  500: '服务器发生错误，请检查服务器。',
  502: '网关错误。',
  503: '服务不可用，服务器暂时过载或维护。',
  504: '网关超时。'
}

const request = axios.create({
  baseURL: Net.baseUrl,
  timeout: 60000 // 请求超时时间
})

request.interceptors.request.use(
  config => {
    NProgress.start()
    // 是否需要设置 token
    const isToken = (config.headers || {}).isToken === false
    if (getToken() && !isToken) {
      config.headers.Authorization = 'CsxhBearer ' + getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    if (config.params) {
      _.forEach(config.params, (param, key) => {
        if (param === null || param === undefined) {
          delete config.params[key]
        }
      })
    }
    if (config.data) {
      _.forEach(config.data, (param, key) => {
        if (param === null || param === undefined) {
          delete config.data[key]
        }
      })
    }
    // 如果是上传文件接口 就不加密
    if (config.url !== '/common/upload') { encryptHandler(config) }
    return config
  },
  error => {
    Promise.reject(error)
  }
)

//  encryption 请求加密 加密
const encryptHandler = config => {
  config.headers['Content-Type'] = 'application/json;charset=UTF-8'
  config.data = encryption.encrypt('w!c_@y(0^sz-xd=h', JSON.stringify(config.data))
  return config
}

// service拦截器
request.interceptors.response.use(
  response => {
    NProgress.done()
    // 请求头中携带加密字段
    if (response.headers.encry === 'true') {
      response.data = JSON.parse(encryption.decrypt('w!c_@y(0^sz-xd=h', response.data))
    }
    if (process.env.NODE_ENV === 'development') {
      // console.log('response : ' + response.config.url, response.data)
    }

    if (response.data && response.data.code === '401') {
      // 未登录
      router.push('/user/login')
      Message.error(response.ret_msg || '对不起，您还未登录，请先登录后再试！')
    }
    if (response.status === 200) {
      if (response.data) {
        return response.data
      }
    } else {
      return Promise.reject(response)
    }
  },
  error => {
    const { response = {} } = error
    const errortext = codeMessage[response.status] || response.statusText
    const { status } = response
    const { url } = response.config
    Notification.error({
      title: `请求错误 ${status}: ${url}`,
      message: errortext
    })
    if (response.data && response.data.code === 401) {
      // 未登录
      router.push('/user/login')
      Message.error(response.ret_msg || '对不起，您还未登录，请先登录后再试！')
    }
    if (error.response.status === 401) {
      // invalid token
      // localStorage.removeItem("Authorization");
      const url = 'user/login'
      window.location.replace(url)
    }
    return Promise.reject(error)
  }
)

export default request
